import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import dayjs from 'dayjs';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID } from './constants';
import 'dayjs/locale/de';
import ApiProvider from './context/api/apiProvider';

dayjs.locale('de-DE');

const cognitoAuthConfig: AuthProviderProps = {
  authority: COGNITO_AUTHORITY,
  client_id: COGNITO_CLIENT_ID,
  redirect_uri: `${window.location.protocol}//${window.location.host}/`,
  response_type: 'code',
  scope: 'email openid profile',
  onSigninCallback: (_: any) => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  extraQueryParams: {
    lang: 'de',
  },
};

const Root = () => {
  return (
    <AuthProvider {...cognitoAuthConfig}>
      <ApiProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApiProvider>
    </AuthProvider>
  );
};

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
